export default "__VITE_ASSET__DttxWw2N__"